import {
  Banner,
  useIsMobileScreenSize,
  WarningIcon,
} from '@buffer-mono/popcorn'

import { useCrossAppNavigate } from '../../../../common/hooks/useCrossAppNavigate'
import { getPublishUrl } from '@buffer-mono/shared-utils/urls'

import type { JSX } from 'react'

const ChannelRefreshBanner = (): JSX.Element => {
  const navigateCrossApp = useCrossAppNavigate()
  const isMobile = useIsMobileScreenSize()

  return (
    <Banner variant="critical" data-testid="channel-refresh-banner">
      <Banner.Text icon={isMobile ? <WarningIcon /> : undefined}>
        {isMobile ? (
          <>Some channels require a refresh</>
        ) : (
          <>
            <strong>Action needed:</strong> Some of your channels need their
            connection refreshed to keep posts publishing smoothly.
          </>
        )}
      </Banner.Text>
      <Banner.Action
        onClick={(): void => {
          navigateCrossApp(getPublishUrl('settings/channels'))
        }}
      >
        Review Channels
      </Banner.Action>
    </Banner>
  )
}

export default ChannelRefreshBanner
